import React, {Component} from "react";
import {Route, Switch as SwitchRoute, Redirect, withRouter} from "react-router-dom";
import WelcomePageR from "./pages/WelcomePage";
import GetVehiclePageR from "./pages/GetVehiclePage";
import VehicleActionsPageR from "./pages/VehicleActionsPage";
import FindMyVehiclePageR from "./pages/FindMyVehiclePage";
import SendPhotoPageR from "./pages/SendPhotoPage";
import VehicleStatePageR from "./pages/VehicleStatePage";
import CheckFuelPageR from "./pages/CheckFuelPage";
import ReturnVehiclePageR from "./pages/ReturnVehiclePage";
import ThankYouPageR from "./pages/ThankYouPage";
import SendCommentPageR from "./pages/SendCommentPage";
import SendRatePageR from "./pages/SendRatePage";
import TurnOffLightsPageR from "./pages/TurnOffLightsPage";
import ReturnKeysPageR from "./pages/ReturnKeysPage";
import ProfilePageR from "./pages/ProfilePage";
import WhereFindKeysPageR from "./pages/WhereFindKeysPage";
import SavingProfileFromRCMPageR from "./pages/SavingProfileFromRCMPage";
import TimerUntilEnd from "./common/TimerUntilEnd";
import TermsAndConditionsPageR from "./pages/TermsAndConditionsPage";
import MessagesPageR from "./pages/MessagesPage";
import MailboxIcon from "./common/MailboxIcon";
import ImportantInformationPageR from "./pages/ImportantInformationPage";
import OurFleetPageR from "./pages/OurFleetPage";
import BookingFormPageR from "./booking/BookingFormPage";
import $ from 'jquery';
import {AJAX} from "./functions";
import {showPopupWithGoBack} from "./popups/PopupWithGoBack";
import moment from "moment";

//expose moment to global
window.moment = moment;

const field_list = {
    get_vehicle: ['resno', 'email'],
    send_comment: ['comment'],
    send_rate: ['rating', 'feedback'],
};

const client_data_fields = ['first_name', 'last_name', 'dob', 'mobile', 'driver_license', 'email',
    'driver_license_issued', 'driver_license_expires', 'address', 'city', 'state', 'postcode'];

const list_path_no_redirect = ['/welcome/', '/profile/', '/terms_and_conditions/', '/messages/', '/hire_information/', '/our-fleet/', '/online-booking/'];

class Pages extends Component {
    constructor(props) {
        super(props);
        this.handleSetPage = this.handleSetPage.bind(this);
        this.handleSetClientData = this.handleSetClientData.bind(this);
        this.handleSetVehicleData = this.handleSetVehicleData.bind(this);
        this.handleSetSessionKey = this.handleSetSessionKey.bind(this);
        this.handleUpdateVehicleState = this.handleUpdateVehicleState.bind(this);
        this.handleSetGlobalOperation = this.handleSetGlobalOperation.bind(this);
        this.setDisallowGoBack = this.setDisallowGoBack.bind(this);
        this.handleSetBookingState = this.handleSetBookingState.bind(this);
        this.handleSetRcmClientData = this.handleSetRcmClientData.bind(this);
        this.getReviews = this.getReviews.bind(this);
        this.handleSetVehicleIsLock = this.handleSetVehicleIsLock.bind(this);
        this.handleSetUnlockNote = this.handleSetUnlockNote.bind(this);
        this.handleSetReturnInstrNote = this.handleSetReturnInstrNote.bind(this);
        this.loadReturnInstructionsNote = this.loadReturnInstructionsNote.bind(this);
        this.state = {
            page_name: 'loading',
            globalOperation: '',
            page_params: {
                get_vehicle: {},
                send_photo: {},
                vehicle_state: {},
                thank_you: {},
                profile:{redirectAtHomeAfterSubmit: false}
            },
            client_data: {},
            rcm_client_data: {},
            vehicle_data: {},
            booking_state: {},
            session_key: '',
            page_with_header: true,
            page_with_banner: true,
            page_with_background: true,
            page_with_top_navigation: true,
            reviews: {
                total_reviews: 0,
                avg_rating: 0,
                list_reviews:0
            },
            vehicleIsLock: true,
            unlock_note: '',
            return_instr_note: '',
        };

        let clientDataFromStorage = JSON.parse(window.localStorage.getItem('client_data'));
        let fields = field_list.get_vehicle;
        if (clientDataFromStorage !== null) {
            for (let i in fields) {
                this.state.client_data[fields[i]] =
                    clientDataFromStorage[fields[i]] !== undefined ?
                        clientDataFromStorage[fields[i]] : '';
            }
        } else {
            for (let i in fields) {
                this.state.client_data[fields[i]] = '';
            }
        }

        this.state.redirectToStart = !list_path_no_redirect.includes(this.props.history.location.pathname);

        this.state.disallowGoBack = false;
        this.state.field_list = field_list;
        this.props.handlePageWithHeader(this.state.page_with_header);
    }

    componentDidMount() {
        this.loadReturnInstructionsNote()
        this.getReviews();
    }

    getReviews() {
        let t = this;
/*/

        $.ajax(window.bm_home_url+'/wp-json/booking/v1/get-reviews', {
            dataType: 'json',
            type: 'GET'
        })
        */
        $.ajax({
            url: bm_ajax_url,
            data: {action: 'get_reviews_json'},
            type: 'GET',
            cache: false,
            dataType: 'json'
        }).done(function (resp) {
            if (resp.success) {
                t.setState({reviews: resp.data});
            }
        })
    }

    handleSetBookingState(value) {
        this.setState({booking_state: value});
        this.setState({session_key: value.session_key})
    }

    componentDidUpdate(prevProps) {
        if (this.state.redirectToStart)
            this.setState({redirectToStart: false});
    }

    handleSetPage(options) {
        let page_with_header = !(options.name === 'loading');
        page_with_header = true;
        this.props.handlePageWithHeader(page_with_header);
        let page_with_banner = true;
        let page_with_background = true;
        let page_with_top_navigation = true;

        switch (options.name) {
            case 'loading':
                page_with_banner = false;
                page_with_background = false;
                page_with_top_navigation = false;
                break;
            case 'find_my_vehicle':
                // page_with_background = false;
                break
        }

        let stateNew = {
            page_name: options.name,
            page_params: this.state.page_params,
            page_with_header: page_with_header,
            page_with_banner: page_with_banner,
            page_with_background: page_with_background,
            page_with_top_navigation: page_with_top_navigation,
        };
        if (options.params !== false) {
            stateNew.page_params[options.name] = options.params === undefined ? {} : options.params;
        }
        this.setState(stateNew);
    }

    handleSetClientData(value) {
        this.setState({
            client_data: value
        }, () => {
            if (Object.keys(this.state.client_data).length)
                window.localStorage.setItem('client_data', JSON.stringify(this.state.client_data));
            else
                window.localStorage.removeItem('client_data');
        });
    }

    handleSetRcmClientData(val) {
        this.setState({rcm_client_data: val})
    }

    handleSetVehicleData(value) {
        this.setState({vehicle_data: value});
    }

    handleSetSessionKey(value) {
        this.setState({session_key: value});
    }

    handleUpdateVehicleState(value) {
        let vehicle_data = this.state.vehicle_data;
        if (vehicle_data.IsDoorLocked === undefined) {
            console.error('Try to change not existing IsDoorLocked property in vehicle data');
            return;
        }

        switch (value) {
            case 'locked':
                vehicle_data.IsDoorLocked = 'True';
                break;
            case 'unlocked':
                vehicle_data.IsDoorLocked = 'False';
                break;
            default:
                console.error('Try to set not allowed vehicle state value');
                return;
        }

        this.handleSetVehicleData(vehicle_data);
    }

    handleSetGlobalOperation(value) {
        if (['lock', 'unlock'].indexOf(value) !== -1) {
            this.setState({globalOperation: value})
            let isLock = 'unlock' === value;
            this.handleSetVehicleIsLock(isLock);
        }
    }

    /*getVehicleState() {
        return this.state.vehicle_data.IsDoorLocked === 'True' || this.state.vehicle_data.IsDoorLocked === true ?
            'locked' :
            'unlocked';
        // return this.state.booking_state.state
    }*/

    setDisallowGoBack(value) {
        this.setState({disallowGoBack: !!value})
    }

    handleSetVehicleIsLock(value) {
        this.setState({vehicleIsLock: !!value})
    }

    handleSetUnlockNote(text) {
        this.setState({unlock_note: text});
    }

    handleSetReturnInstrNote(text) {
        this.setState({return_instr_note: text});
    }

    loadReturnInstructionsNote() {
        if (window.localStorage.getItem('start_timer') === '1') {
            let clientDataFromStorage = JSON.parse(window.localStorage.getItem('client_data'));
            if (clientDataFromStorage !== null) {
                let t = this;
                let params = {
                    resno: clientDataFromStorage.resno,
                    email: clientDataFromStorage.email,
                    action: 'api/booking/get_return_instructions',
                    location: ''
                }
                let locations = JSON.parse(window.localStorage.getItem('vehicle_locations'));
                if (locations !== null && locations.DropOffLocationName)
                    params.location = locations.DropOffLocationName
                AJAX(bm_ajax_url, 'POST', params, {
                    response_json: true,
                    func_callback: function (resp) {
                        if (typeof resp.data.return_instr_note === 'string') {
                            t.handleSetReturnInstrNote(resp.data.return_instr_note)
                        }
                    },
                    func_error: function (resp) {
                        showPopupWithGoBack(resp.message);
                    }
                });
            }
        }
    }

    content() {
        return (
            <SwitchRoute>
                <Route exact path="/welcome">
                    <WelcomePageR client_data={this.state.client_data}
                                 reviews={this.state.reviews}
                                 handleSetPage={this.handleSetPage}
                                 handleSetGlobalOperation={this.handleSetGlobalOperation}
                                 return_instr_note={this.state.return_instr_note}
                    />
                </Route>
                <Route exact path="/get_vehicle">
                    <GetVehiclePageR field_list={this.state.field_list}
                                    page_params={this.state.page_params.get_vehicle}
                                    handleSetPage={this.handleSetPage}
                                    handleSetVehicleData={this.handleSetVehicleData}
                                    handleSetClientData={this.handleSetClientData}
                                    handleSetRcmClientData={this.handleSetRcmClientData}
                                    client_data={this.state.client_data}
                                    handleSetSessionKey={this.handleSetSessionKey}
                                    global_operation={this.state.globalOperation}
                                    setDisallowGoBack={this.setDisallowGoBack}
                                    handleSetBookingState={this.handleSetBookingState}
                                    handleSetReturnInstrNote={this.handleSetReturnInstrNote}
                    />
                </Route>
                <Route exact path="/vehicle_actions">
                    <VehicleActionsPageR
                        handleSetPage={this.handleSetPage}
                        car_image={this.state.vehicle_data.CarImage}
                        vehicle_data={this.state.vehicle_data}
                        vehicleIsLock={this.state.vehicleIsLock}
                    />
                </Route>
                <Route exact path="/find_my_vehicle">
                    <FindMyVehiclePageR
                        // coordinates={{lat: this.state.vehicle_data.Latitude, lng: this.state.vehicle_data.Longitude}}
                        handleSetPage={this.handleSetPage}
                        session_key={this.state.session_key}
                    />
                </Route>
                <Route exact path="/send_photo/:operation/:photo">
                    <SendPhotoPageR global_operation={this.state.globalOperation}
                        // page_params={this.state.page_params.send_photo}
                        // operation={match.params.operation}
                        // photo={match.params.photo}
                                    client_data={this.state.client_data}
                                    handleSetPage={this.handleSetPage}
                                    session_key={this.state.session_key}
                                    files={this.state.booking_state.files}
                                    handleSetBookingState={this.handleSetBookingState}
                                    vehicle_data={this.state.vehicle_data}
                    />
                </Route>
                <Route exact path="/vehicle_state">
                    {
                        (this.state.booking_state.state === undefined || this.state.session_key === '') ?
                            (()=>window.location.href = bm_base_path)
                            : (<VehicleStatePageR global_operation={this.state.globalOperation}
                                                 vehicle_data={this.state.vehicle_data}
                                                 handleSetPage={this.handleSetPage}
                                                 handleUpdateVehicleState={this.handleUpdateVehicleState}
                                                 session_key={this.state.session_key}
                                                 client_data={this.state.client_data}
                                                 // vehicle_state={this.getVehicleState()}
                                                 car_image={this.state.vehicle_data.CarImage}
                                                 disallowGoBack={this.state.disallowGoBack}
                                                 setDisallowGoBack={this.setDisallowGoBack}
                                                 handleSetBookingState={this.handleSetBookingState}
                                                 vehicleIsLock={this.state.vehicleIsLock}
                                                 handleSetVehicleIsLock={this.handleSetVehicleIsLock}
                                                 handleSetUnlockNote={this.handleSetUnlockNote}
                            />)

                    }
                </Route>
                <Route exact path="/where_keys">
                    <WhereFindKeysPageR />
                </Route>
                <Route exact path="/check_fuel">
                    <CheckFuelPageR handleSetPage={this.handleSetPage}
                                   booking_state={this.state.booking_state}
                                   handleSetBookingState={this.handleSetBookingState}
                                   client_data={this.state.client_data}
                                   session_key={this.state.session_key}
								   global_operation={this.state.globalOperation}
                    />
                </Route>
                <Route exact path="/return_vehicle/step/:step">
                    <ReturnVehiclePageR handleSetPage={this.handleSetPage}
                                        client_data={this.state.client_data}
                                        session_key={this.state.session_key}
										global_operation={this.state.globalOperation}
                                        booking_state={this.state.booking_state}
                                        handleSetBookingState={this.handleSetBookingState}
                                        return_instr_note={this.state.return_instr_note}
                    />
                </Route>
                <Route exact path="/turn_off_lights">
                    <TurnOffLightsPageR handleSetPage={this.handleSetPage}
                                    client_data={this.state.client_data}
                                    session_key={this.state.session_key}
									global_operation={this.state.globalOperation}
                                    booking_state={this.state.booking_state}
                                    handleSetBookingState={this.handleSetBookingState}
                    />
                </Route>
                <Route exact path="/return_keys">
                    <ReturnKeysPageR handleSetPage={this.handleSetPage}
                                    client_data={this.state.client_data}
                                    session_key={this.state.session_key}
									global_operation={this.state.globalOperation}
                                    booking_state={this.state.booking_state}
                                    handleSetBookingState={this.handleSetBookingState}
                    />
                </Route>
                <Route exact path="/thank_you">
                    <ThankYouPageR global_operation={this.state.globalOperation}
                                  session_key={this.state.session_key}
                                  handleSetPage={this.handleSetPage}
                                  unlock_note={this.state.unlock_note}
                    />
                </Route>
                <Route exact path="/send_comment">
                    <SendCommentPageR field_list={this.state.field_list}
                                     handleSetPage={this.handleSetPage}
                                     session_key={this.state.session_key}
                                     global_operation={this.state.globalOperation}
                                     booking_state={this.state.booking_state}
                                     handleSetBookingState={this.handleSetBookingState}
                    />
                </Route>
                <Route exact path="/send_rate">
                    <SendRatePageR field_list={this.state.field_list}
                                  handleSetPage={this.handleSetPage}
                                  session_key={this.state.session_key}
                                  global_operation={this.state.globalOperation}
                                  booking_state={this.state.booking_state}
                                  handleSetBookingState={this.handleSetBookingState}
                                  vehicle_data={this.state.vehicle_data}
                    />
                </Route>
                <Route exact path="/your_data_saving">
                    <SavingProfileFromRCMPageR client_data_fields={client_data_fields}
                                              rcm_client_data={this.state.rcm_client_data}
                                              // rcm_client_data={window.gClientData}
                                              session_key={this.state.session_key}
                                              global_operation={this.state.globalOperation}
                    />
                </Route>
                <Route exact path="/profile">
                    <ProfilePageR handleSetPage={this.handleSetPage}
                                 // handleSetClientData={this.handleSetClientData}
                                 client_data_fields={client_data_fields}
                                 client_data={this.state.client_data}
                                 page_params={this.state.page_params.profile}
                    />
                </Route>
                <Route exact path="/terms_and_conditions">
                    <TermsAndConditionsPageR />
                </Route>
                <Route exact path="/messages">
                    <MessagesPageR />
                </Route>
                <Route exact path="/hire_information">
                    <ImportantInformationPageR />
                </Route>
                <Route exact path={'/our-fleet'}>
                    <OurFleetPageR />
                </Route>
                <Route exact path="/online-booking/">
                    <BookingFormPageR handleSetPage={this.handleSetPage}
                    />
                </Route>
            </SwitchRoute>
        )
    }

    render() {
        if (this.state.redirectToStart) {
            return <Redirect push to='/welcome/'/>;
        }

        return (
            <div className={'h-100'}>
                {
                    this.state.page_with_header ? (
                        <div className="header-space">
                            <div className="header-logo-banner">
                                <a href={bm_base_path + '/welcome/'} className="gwtg-text-logo" />
                                {/*<div className="gwtg-text-logo" />*/}
                            </div>
                        </div>
                    ) : ('')
                }
                <div
                    id={'id_scrolling_div'}
                    className={(this.state.page_with_header ? 'page-with-header' : 'page-without-header') + ' ' + (this.state.page_with_banner ? 'page-with-banner' : 'page-without-banner')}>
                    {
                        this.state.page_with_top_navigation ? (
                            <div className="top-navigation">
                                <div className="timer_until_end_wrap">
                                    <TimerUntilEnd />
                                </div>
                                <div className="d-flex flex-column btns-nav">
                                    <div className="d-flex align-items-center flex-column">
                                        <a href="tel:1300826883" className="btn-call-to-gecko green sm-size"/>
                                        <span className="text-btn-navigation">Need help?</span>
                                    </div>
                                    <div className="d-flex align-items-center flex-column mt-1">
                                        <MailboxIcon currentPathName={this.props.history.location.pathname} />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ''
                        )
                    }
                    {
                        this.state.page_with_background ? (
                            <div className="content-main">
                                <div className="content-logo" />
                                <div className="content-bg-arc" />
                                <div className="content-bg-base" />
                                <div className="content-value">
                                    {this.content()}
                                </div>
                            </div>

                        ) : (this.content())
                    }
                </div>
                {
                    this.state.page_with_banner ? (
                        <div className="banner-space">
                            <img src={init_plugin_dir + '../images/gwtg-fake-ad-new.webp'} alt="Banner"/>
                        </div>
                    ) : ('')
                }
            </div>
        );
    }
}

const PagesR = withRouter(Pages);
export default PagesR;
